import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function notEmptyValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any}  => {
    let value = control.value || '';

    if (value && typeof value.trim !== 'undefined') {
      value = value.trim();
    }

    return (value === '' || !value) ? { emptyField: true } : null;
  };
}

@Directive({
  selector: '[appValidateEmpty]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotEmptyValidatorDirective, multi: true }],
})
export class NotEmptyValidatorDirective {}
